import React from 'react';
import { usePathname } from 'next/navigation';
import { JoinFlowButtons } from './JoinFlowButtons';
import { UpgradeFlowButtons } from './UpgradeFlowButtons';

export type CartButtonVariants =
  | 'continueToCheckout'
  | 'control'
  | 'preferCheckout'
  | 'chooseUpgradeOption'
  | 'chooseUpcycleOption';

export interface CartCTAButtonsProps {
  variant: CartButtonVariants;
  showOnlyPrimaryButton?: boolean;
  skipMemSelectFlow?: string;
  isUpcycleExperimentVariant?: boolean;
  showTrialBlock?: boolean;
}

export function CartCTAButtons({
  variant,
  showOnlyPrimaryButton = false,
  skipMemSelectFlow,
  showTrialBlock = false,
}: CartCTAButtonsProps): React.JSX.Element {
  const pathname = usePathname();
  const isUpgradeFlow = pathname.includes('upgrade');

  // Render appropriate flow component with flow-specific logic
  if (isUpgradeFlow) {
    return (
      <UpgradeFlowButtons
        showOnlyPrimaryButton={showOnlyPrimaryButton}
        variant={variant}
      />
    );
  }

  return (
    <JoinFlowButtons
      showOnlyPrimaryButton={showOnlyPrimaryButton}
      variant={variant}
      skipMemSelectFlow={skipMemSelectFlow}
      showTrialBlock={showTrialBlock}
    />
  );
}
